<template>
  <div class="application-container">
        <div class="banner-container">
            <img class="backgroundImg" :src="getBackgroundImg()" alt="底图加载失败">
            <div class="backgroundCover"></div>
            <div class="title">
                <div class="item">他们都在使用飞视</div>
                <div class="item">N+应用领域，70+AI识别场景</div>
            </div>
            <svg-icon class="arrow-icon" icon-class="application-1"></svg-icon>
            <div class="banner-box">
                <div class="description-box" :style="ApplicatioLayout[0][items.id-1]" v-for="(items,id) in applicationData" :key="id" 
                    @mouseover="changeApplicatioLayout(items.id)" @mouseenter="pauseTimer()" @mouseleave="restartTimer()">
                    <img :src="items.imgURL" alt="图片加载失败">
                    <div class="cover" :style="ApplicatioLayout[1][items.id-1]">
                        <p class="subtitle" :style="ApplicatioLayout[4][items.id-1]">{{items.title}}</p>
                    </div>
                    <div class="cover-background" :style="ApplicatioLayout[2][items.id-1]"></div>
                    <div class="item-box" :style="ApplicatioLayout[3][items.id-1]">
                        <div class="item" v-for="(item,key) in items.description" :key="key">
                            {{item}}
                        </div>
                    </div>
                </div>
                <div class="description-box">
                    <p>更多领域</p>
                    <p>持续性满足客户需求</p>
                </div>
            </div>
        </div>
        <!-- 经典案例 -->
        <div class="case-container">
            <div class="title">
                <div class="item">经典案例</div>
                <div class="item">众多优秀政企选择了飞视，客户满意度一致好评</div>
            </div>
            <div class="case-box">
                <div class="case-item" v-for="(item,key) in displayedCase" :key="key" @mouseenter = "caseHoverID = item.id" @mouseleave = "caseHoverID = -1">
                    <img class="backgroundImg" :src="item.imgURL" alt="背景图片加载失败">
                    <div class="cover">
                        <div class="trigger"></div>
                        <p class="title">{{item.title}}</p>
                        <p class="content-normal">{{item.content}}</p>
                        <p class="content-hover">{{item.content}}</p>
                    </div>
                </div>
            </div>
            <el-button class="more-btn" @click="loadmore()" v-if="bottonVisible">
                <span class="btn-content">加载更多</span>
                <svg-icon class="arrow-icon" icon-class="application-2"></svg-icon>
            </el-button>
        </div>
        <!-- 联系我们 -->
        <div class="contact-container">
            <div class="title">想要了解更多行业应用、解决方案及典型案例？</div>
            <el-button class="contact-btn" @click="contactVisible = true"> <span>联系我们</span> </el-button>
        </div>
        <!-- 联系我们表单 -->
        <div class="contact-form-container" v-if="contactVisible">
            <div class="contact-form-box">
                <Contact class="contact-form-item" :contactVisible="contactVisible" @handleContactVisible="handleContactVisible"></Contact>
                <img class="close" :src="require('@/assets/images/HomePage/siedbar/close.png')" alt="关闭图标加载失败" @click="contactVisible = false">
            </div>
        </div>
  </div>
</template>

<script>
import Contact from './Contact.vue'

export default {
    name: 'HomePage',
    components:{
        Contact
    },
    data(){
        return{
            showBackground :false,
            timerID: null, // 用于存储定时器的ID 
            applicationData:[
                {id:1,title:"工业园区",imgURL:require('@/assets/images/HomePage/application/工业园区.png'),description:[
                    "工程3D建模","安全防护栏丢失","裸土未覆盖","疑似污水","工地扬尘",
                    "渣土乱倒","工地出入口未硬化","施工废弃料","渣土车未覆盖","……"
                ]},
                {id:2,title:"农林水利",imgURL:require('@/assets/images/HomePage/application/农林水利.png'),description:[
                    "水域不洁","松材线虫病","焚烧秸秆","大棚破损","河道污染",
                    "耕地两非","非法盗采","水利工程","非法排污","……"
                ]},
                {id:3,title:"城市管理",imgURL:require('@/assets/images/HomePage/application/城市管理.png'),description:[
                    "违停车辆","井盖破损","渣土车辆","违章建筑","交通疏导",
                    "流动摊贩","店外经营","垃圾满溢","占道广告牌","……"
                ]},
                {id:4,title:"道路交通",imgURL:require('@/assets/images/HomePage/application/道路交通.png'),description:[
                    "车辆违停","交通标志线模糊","道路积泥沙","道路积水","交通事故",
                    "交通标志牌倾斜","井盖缺失","路面坍塌","道路破损","……"
                ]},
                {id:5,title:"乡镇街道",imgURL:require('@/assets/images/HomePage/application/乡镇街道.png'),description:[
                    "在建农房","附属房建筑","附属房建材","危房隐患","暴露垃圾",
                    "边坡坍塌","非粮非农化","人群聚集","占道经营","……"
                ]},
                {id:6,title:"应急救援",imgURL:require('@/assets/images/HomePage/application/应急救援.png'),description:[
                    "疑似烟火","消防通道堵塞","黑烟污染","人员聚集","交通事故",
                    "山体滑坡","洪涝灾害","发生火灾","……",
                ]}
            ],
            applicationHoverID:1,
            ApplicatioLayout:[
                [{flex: '2',flexBasis: '25%'},{flex: '1',flexBasis: '12.5%'},{flex: '1',flexBasis: '12.5%'},{flex: '1',flexBasis: '12.5%'},{flex: '1',flexBasis: '12.5%'}],
                [{background: '#0271e3e6'},{background: '#00000080'},{background: '#00000080'},{background: '#00000080'},{background: '#00000080'},{background: '#00000080'}],//按钮背景   
                [{opacity:'1'},{opacity:'0'},{opacity:'0'},{opacity:'0'},{opacity:'0'},{opacity:'0'}],//阴影  
                [{opacity:'1'},{opacity:'0'},{opacity:'0'},{opacity:'0'},{opacity:'0'},{opacity:'0'}],//文字 
                [{fontSize: '18px'},{fontSize: '16px'},{fontSize: '16px'},{fontSize: '16px'},{fontSize: '16px'},{fontSize: '16px'}],//subtitle 
            ],
            caseData:[
                {id:0,imgURL:require('@/assets/images/IndustryApplication/市域一体组网.jpg'),title:"市域一体组网",content:"某市强化数字手段赋能基层治理，打造“市域一体组网、问题智能识别、处置协同高效、信息联合共享”的智慧巡检模式。全市部署了数十台无人机巢（一机一巢），覆盖城市建成区和35个赋权乡镇，全域巡检效率提升10倍以上，推动联合处置问题数量提高124%，助力群众满意度由68%上升至91%，基层办件量上升的同时，平均处置时长和信访投诉率均下降，不断赋能改革实践。"},
                {id:4,imgURL:require('@/assets/images/IndustryApplication/执法检查.jpg'),title:"执法检查",content:"某县布设固定机槽无人机8台，巡检范围覆盖主城区和工业园区。此外会同大数据部门推进隶属各单位的25台手控无人机飞行数据组网。系统已完成建筑施工、市容秩序、公共设施、水域和林区5大类43个采集应用场景建设，飞一次就可完成多项数据采集交办。将原本需要数月完成的市域全覆盖巡查缩短到数天，城市管理效率和效能将得到大幅提升"},
                {id:1,imgURL:require('@/assets/images/IndustryApplication/国家公园巡检.jpg'),title:"国家公园巡检",content:"浙江省某国家公园管理局投入14余架无人机，通过日常巡检，实时画面监控、大数据分析，实现可定位的松材线虫病、森林防火等场景智能预警，时刻保卫国家公园生态环境。自2022年与飞视合作，共计代替人工4669人次、33657公里、节约成本125.84万元、减少碳排放8.41吨。"},
                {id:6,imgURL:require('@/assets/images/IndustryApplication/秸秆焚烧专项巡查.jpg'),title:"秸秆焚烧专项巡查",content:"秋冬季为秸秆焚烧的重点时段，某市开展无人机常态巡查。每一台自动化无人机每天要飞4-10个架次，形成了一张更加紧密高效的巡检网络，做到全天候巡查，第一时间发现秸秆焚烧行为。发现并推动解决秸秆焚烧事件400余起，有效提升了基层工作人员的巡查效率和处置速度。"},
                {id:3,imgURL:require('@/assets/images/IndustryApplication/汛期巡检.jpg'),title:"汛期巡查",content:"通过巡查点位规划、自动航线规划、自动飞行采集、自动合成全景、巡查成果查看流程，关注城市内涝和江河水势，及时发出防汛预警，浙江xx市43架无人机12小时完成全市46个点位的主要河道巡查,相较人工巡查效率提升10倍以上，实战效果显著。"},
                {id:13,imgURL:require('@/assets/images/IndustryApplication/林业巡检.jpg'),title:"林业巡检",content:"xx企业与飞视合作，确认方案以无人值守机场+无人机集群控制+AI人工智能识别为核心技术，聚焦森林防火、病虫害监测、野生动植物保护、森林资源保护等应用场景，为国家公园、国家森林公园、自然保护区、国有林场、湿地公园等生态保护区，以及各级林业部门提供全天候、全方位、全要素、多事件、多场景的综合应用服务。"},
                {id:2,imgURL:require('@/assets/images/IndustryApplication/火灾巡查.jpg'),title:"火灾巡查",content:"通过红外热成像功能确认大面积火情，第一时间通知xx镇综合信息指挥室并推送定位，网格员、消防员陆续到达现场扑救。期间无人机持续协助观测火情变化。明火被扑灭，仅用时38分钟。根据预案，无人机继续开展红外监测，两次发现高温点复燃并及时扑灭，实现“打早、打小、打了”。"},
                {id:5,imgURL:require('@/assets/images/IndustryApplication/违规建设.jpg'),title:"违规建设",content:"通过无人机巡检发现，某乡镇存在疑似违规建设农房现象，抓拍识别取证后，该预警信息经市域治理平台推送至乡镇基层治理四平台进行处置。后经乡镇执法队员现场核实，及时叫停未取得审批进行建设的行为。"},
                {id:7,imgURL:require('@/assets/images/IndustryApplication/河道巡检.jpg'),title:"河道巡检",content:"某地通过创建特定航线，常态巡查，定期对河道进行进行图像收集并识别场景问题，对非法捕捞、非法垂钓、涉水人员进行喊话警告，识别河道污染源，发现污染源自动立即上报相应部门进行处理。真正做到全程无人化作业。解决传统河道巡检水域面积大、范围广，人力巡检效率低等痛点问题。"},
                {id:8,imgURL:require('@/assets/images/IndustryApplication/乡村治理.jpg'),title:"乡村治理",content:"利用三维云建模、计算机视觉、计算机图形学、三维可视化开发等系列技术，实现无人机的高频、自动空中巡检，回传影像数据的智能化处理及可视化展示，某镇政府显著提高了农房建设、乡村环境、农田利用管理等方面的监管效率。针对农房建设违规、耕地的“非农化”或“非粮化”、污水垃圾违规排放等突出问题，称无人机巡检的效率比人工巡检提升5倍以上。"},
                {id:9,imgURL:require('@/assets/images/IndustryApplication/建筑工地管理.jpg'),title:"建筑工地管理",content:"某地数字经济产业园，利用无人机全自动高效采集工程数据，快速生成高精度二三维模型。高效监测工地建设进度。此外，配置工地巡检场景相关算法， 7×24 小时监测工地现场，保障安全生产。通过日常飞行，AI识别相应问题，巡检过程中发现”未安装防护设施”的问题，立即现场处置，杜绝安全问题发生。"},
                {id:11,imgURL:require('@/assets/images/IndustryApplication/道路安全.jpg'),title:"道路安全",content:"针对城市道路多，人力巡检成本高，安全隐患大等痛点，某县配置了道路安全相关问题识别算法，一日，在日常全覆盖巡检过程，AI识别井盖破损问题并自动上报，相关部门立刻线上交办，联系线下人员根据定位很快解决了该问题，形成了业务闭环。"},
                {id:10,imgURL:require('@/assets/images/IndustryApplication/数字城市.jpg'),title:"数字城市",content:"某市利用平台自动巡检及数字孪生等功能，在平台构建起了数字城市实景底图。通过日常飞行自动建模，平台周期性更新三维模型、二维模型、全景模型，实现城市治理足不出户观全局；解决了在资源和环境管理等方面如数据信息分散、沟通协作不便、效率低等问题。"},
                {id:12,imgURL:require('@/assets/images/IndustryApplication/废气偷排.jpg'),title:"废气偷排",content:"某市无人机在空中巡检时，发现一工业区有企业疑似不正常运行大气污染防治设施并排放污染物。无人机进行现场拍照后将该情况上传，综合执法第二大队队员立刻对该事件查收、受理，并联合市资规局在第一时间赶赴现场进行了核实、处置。"},
            ],
            displayItems:8,
            caseHoverID:-1,
            bottonVisible:true,
            contactVisible:false
        }
    },
    computed: {  
    // 使用计算属性来动态生成显示的div数组  
        displayedCase() {  
            let items = [];  
            for (let i = 0; i < this.displayItems ; i++) {  
                items.push(this.caseData[i]);  
            }  
            return items;  
        }
    },
    methods:{
        startTimer() {  //添加定时器
            this.timerID = setInterval(() => {  
                let ID = (this.applicationHoverID) % this.applicationData.length + 1;  
                this.changeApplicatioLayout(ID);
            }, 3000); // 每隔1秒切换一次
        },
        pauseTimer() {  // 暂停定时器  
            clearInterval(this.timerID);  
            this.timerID = null;  
        },
        restartTimer(){
            if(!this.timerID){
                this.startTimer();
            }
        },
        getBackgroundImg(){
            return this.applicationData[this.applicationHoverID-1].imgURL;
        },
        changeApplicatioLayout(id){
            
            this.ApplicatioLayout[0][this.applicationHoverID-1] = {flex:'1',flexBasis: '12.5%'};
            this.ApplicatioLayout[1][this.applicationHoverID-1] = {background: '#00000080'};
            this.ApplicatioLayout[2][this.applicationHoverID-1] = {opacity:'0',transition:'0.5s ease'};
            this.ApplicatioLayout[3][this.applicationHoverID-1] = {opacity:'0',transition:'0.2s ease'};
            this.ApplicatioLayout[4][this.applicationHoverID-1] = {fontSize: '16px'};

            this.applicationHoverID = id;

            this.ApplicatioLayout[0][this.applicationHoverID-1] = {flex:'2',flexBasis: '25%'};
            this.ApplicatioLayout[1][this.applicationHoverID-1] = {background: '#0271e3e6'};
            this.ApplicatioLayout[2][this.applicationHoverID-1] = {opacity:'1'};
            this.ApplicatioLayout[3][this.applicationHoverID-1] = {opacity:'1',transition:'0.2s ease 0.2s'};
            this.ApplicatioLayout[4][this.applicationHoverID-1] = {fontSize: '18px'};

            this.$forceUpdate()
        },
        getContentLayout(id){
            if(this.caseHoverID === id) return "content-hover";
            else return "content-normal";
        },
        loadmore(){
            if(this.displayItems <= 14){
                this.displayItems = 14;
            }
            this.bottonVisible = false;
        },
        handleContactVisible(message) {  
            this.contactVisible = message;
        } 
    },
    mounted() {  
        this.startTimer();  
    },  
    beforeDestroy() {  // 组件销毁前清除定时器  
        if (this.timerID) {  
            clearInterval(this.timerID);  
        }  
    }, 
}
</script>

<style lang="scss" scoped>
.application-container{
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    color: #FFFFFF;
    background-color: #000000;
    padding: 0px;
    margin: 0;
    position: relative;
}
.banner-container{
    position: relative;
    width: 100%;
    min-height: 780px;
    max-height: 1080px;
    height: 100vh;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .backgroundImg{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        top: 0%;
        left: 0%;
    }
    .backgroundCover{
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        top: 0%;
        left: 0%;
        background: #000000bf;
        backdrop-filter: blur(20px);
    }
    .title{
        position: absolute;
        z-index: 3;
        top: 13.25%;
        width: 100%;
        color: #FFFFFF;
        text-align: center;
        margin: 0;
        .item{
            &:first-of-type{    
                height: 64px;
                font-weight: 500;
                font-size: 42px;
                line-height: 64px;
                text-align: center;
                margin: 0;
                margin-bottom: 8px;
            }
            &:last-of-type{
                height: 32px;
                font-weight: 400;
                font-size: 18px;
                color: #FFFFFF;
                letter-spacing: 0.9px;
                text-align: center;
                line-height: 32px;
            }
        }
    }
    .arrow-icon{
        position: absolute;
        z-index: 3;
        top:34.15%;
        width: 24px;
        height: 12px;
        margin: 0;
    }
    .banner-box{
        position: absolute;
        top: 43.85%; 
        bottom: 60px;
        width: calc(100% - 80px);
        max-width: 1440px;
        max-height: 520px;
        min-height: 396px;
        height: 50%;
        display: flex;
        z-index: 3;

        .description-box{
            flex: 1;
            flex-basis: 12.5%;
            max-width: 360px;
            height: 100%;
            position: relative;
            margin: 0;
            overflow: hidden;
            text-align: center;
            padding: 0;
            transition: 0.6s ease;
            
            background-color: #00000080;

            img{
                position: absolute;
                z-index: 4;
                width: 100%;
                height: 100%;
                object-fit: cover;
                overflow: hidden;
                left: 0%;
                transition: transform 0.6s ease; // 平滑过渡效果  
            }
            .cover{
                position: absolute;
                left: 0%;
                z-index: 5;
                margin: 0;
                width: 100%;
                height: 68px;
                background: #00000080;
                backdrop-filter:blur(5px);
                display: flex;
                align-items: center;
                text-align: center;
                transition: 0.6s ease;

                .subtitle{
                    width: 100%;
                    height: 30px;
                    font-weight: 500;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 30px;
                    margin: 0;
                }
            }
            .cover-background{
                position: absolute;
                width: 100%;
                height: 100%;
                background: #00000099;
                z-index: 4;
            }
            .item-box{
                position: absolute;
                width: 100%;
                height: auto;
                margin-top: 68px;
                opacity: 0;
                padding: 60px 20px;
                z-index: 6;
                text-align: center;
                display: flex;
                flex-wrap: wrap; /*允许子元素换行*/
                white-space:nowrap;
                overflow: hidden;
                align-items: center;

                .item{
                    flex: 1 0 50%;
                    height: 36px;
                    box-sizing: border-box;/*是的padding和border包含在元素宽度内*/
                    margin: 0;
                    margin-bottom: 10px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 36px;
                    flex-wrap:nowrap;
                    white-space:nowrap;
                }
            }
            &:last-of-type{
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                justify-content: center;
                p{
                    &:first-of-type{
                        height: 22px;
                        font-weight: 500;
                        font-size: 16px;
                        color: #FFFFFF;
                        margin: 0;
                    }
                    &:last-of-type{
                        height: 20px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #ffffffbf;
                        margin: 0;
                        margin-top: 10px;
                    }
                }
            }
        }

        @media (max-width: 1200px) { 
            .item-box{
                flex-direction: column;
                flex: 1;
                padding: 0 20px !important;
                .item{
                    font-size: 14px;
                    margin: 0;
                }
            }
        }
    }
}
/* 经典案例 */
.case-container{
    width: 100%;
    height: auto;
    background-color: #FFFFFF;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 80px;

    > .title{
        width: 100%;
        margin-top: 60px;
        .item{
            text-align: center;
            margin: 0;
            &:first-of-type{
                height: 60px;
                font-weight: 500;
                font-size: 36px;
                color: #000000;
                line-height: 60px;
            }
            &:last-of-type{
                height: 24px;
                font-weight: 400;
                font-size: 16px;
                color: #000000bf;
                line-height: 24px;
            }
        }
    }
    .case-box{
        width: calc(100% - 80px);
        max-width: 1440px;
        margin: 0;
        margin-top: 48px;
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* 创建两列，每列占据可用空间的一等份 */  
        grid-auto-rows: 260px; /*每行高度*/
        row-gap: 50px; /* 行间距 */  
        column-gap: 40px; /* 列间距 */ 
        box-sizing: border-box; /* 确保padding不会增加容器的总宽度 */

        .case-item{
            height: 100%;
            width: 100%;
            border-radius: 4px;
            position: relative;
            box-sizing: border-box;
            
            .backgroundImg{
                width: 100%;
                height: 100%;
                flex-shrink: 1;
                object-fit: cover;
                object-position: center;
                border-radius: 4px;
                position: absolute;
                z-index:1;
            }
            .cover{
                position: absolute;
                z-index: 2;
                max-width: 240px;
                width: 34.3%;
                height: 100%;
                background: #00000080;
                border-radius: 4px 0 0 4px;
                transition: 0.3s ease;
                box-sizing: border-box;

                .trigger{
                    position: absolute;
                    z-index: 3;
                    width: 32px;
                    height: 3px;
                    background: #FFFFFF;
                    top: 43.85%;
                    left: 24px;;
                    transition: top 0.5s ease;
                }
                > .title{
                    height: 24px;
                    font-weight: 500;
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 24px;
                    margin: 0;
                    position: absolute;
                    z-index: 3;
                    top: 52.7%;
                    padding: 0 24px;
                    transition: top 0.5s ease;
                }
                .content-normal{
                    position: absolute;
                    z-index: 3;
                    top: 67.7%;
                    max-width: 240px;
                    width: 100%;
                    height: 16.9%;
                    margin: 0;
                    padding: 0 24px;
                    // 当需要时，你可以设置一个固定的高度，但请注意这可能会截断文字 
                    display: -webkit-box;  
                    -webkit-line-clamp: 2; // 限制显示的行数  
                    -webkit-box-orient: vertical;  
                    overflow: hidden;  
                    text-overflow: ellipsis; // 显示省略号  

                    font-weight: 400;
                    font-size: 14px;
                    color: #ffffffe6;
                    text-align: justify;
                    line-height: 22px;
                    
                    
                    opacity: 1;
                    transition: opacity 0.1s ease, top 0.5s ease;
        
                }
                .content-hover{
                    position: absolute;
                    z-index: 3;
                    top: 50.77%;
                    max-width: 700px;

                    width: 100%;
                    height: 16.9%;
                    margin: 0; 
                    padding: 0 24px;
                    overflow: hidden;
                    text-overflow: ellipsis; // 显示省略号  

                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: justify;
                    line-height: 22px;

                    opacity: 0;
                    transition: opacity 0.1s ease;
                }

                &:hover{
                    .content-normal{
                        top: 50.77%;
                        opacity: 0;
                        transition: opacity 0.3s ease, top 0.3s ease;
                    }
                    .content-hover{
                        opacity: 1;
                        height: 40%;
                        overflow: auto;
                        transition: opacity 0.3s ease 0.2s, height 0s ease 0.2s;
                    }
                }
            }
            
            &:hover{
                .cover{
                    max-width: 700px;
                    width: 100%;
                    border-radius: 4px;
                    background: #00000099;
                    backdrop-filter: blur(5px);
                }
                .trigger{
                    top:26.9%;
                }
                .title{
                    top:35.77%;
                }
            }
        }
    }
    .more-btn{
        width: 160px;
        height: 40px;
        border: 1px solid #000000;
        border-radius: 24px;
        margin-top: 40px; 

        .btn-content{
            width: 56px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
        }
        .arrow-icon{
            width: 12px;
            height: 6px;
            margin-left: 8px;
        }
        .svg-icon{
            vertical-align: 0.1em;
        }

        &:hover{
            background-color: #FFFFFF;
        }
        
    }
}
/* 联系我们 */
.contact-container{
    width: 100%;
    height: 300px;
    background-image: url('@/assets/images/IndustryApplication/contact.png');
    background-size: cover;  
    background-position: center; 
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .title{
        margin:0;
        margin-top: 90px;
        height: 40px;
        font-weight: 500 ;
        font-size: 28px;
        color: #000000;
        text-align: center;
    }
    .contact-btn{
        width: 200px;
        height: 48px;
        margin: 0;
        margin-top: 34px;
        background-color: #0271E3;
        border-radius: 24px;

        span{
            height: 25px;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
        }
    }
}
/* 预约试用 */
.contact-form-container{
    width: 100vw;
    height: 100vh;
    background: #00000099;
    backdrop-filter: blur(8px);
    position: fixed;
    z-index: 120;
    top:0%;
    left:0%;

    .contact-form-box{
        position: relative;
        z-index: 121;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%); // 向左和向上移动自身宽高的一半，实现完全居中
        height: 480px;
        max-width: 780px;
        width: 40.6%;
        flex:1;
        background-color: rgba(255, 255, 255, 0); // 白色背景，50%透明度 
        .contact-form-item{
            width:100%;
            height: 100%;

        }
        .close{
            position: absolute;
            z-index: 122;
            height: 36px;
            width: 36px;
            flex:1;
            top:-40px;
            right:-40px;
            &:hover{
                cursor: pointer; 
            }
        }
    }
    

}
</style>